// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { LibrarySessionId, LibrarySubsessionInfo } from "../../../Libs/TradingViewChart/charting_library_cloned_data/charting_library/charting_library";
import { TvSessionIdEnum } from "./TvEnums";



export class TvSubsessionInfo implements LibrarySubsessionInfo
{
    public description = '';
    public id: LibrarySessionId = TvSessionIdEnum.regular;
    public session = '';

    setCorrection(correction)
    {
        if (correction) {
            this["session-correction"] = correction;
        }
    }

    getCorrection()
    {
        return this["session-correction"];
    }
}